<mat-icon
  class="menu-icon"
  (click)="openMenu()"
  data-cy="mobile-menu-toggle-icon"
>menu</mat-icon>
<mat-sidenav-container>
  <mat-sidenav
    #sidenav
    [autoFocus]="false"
  >
    <div
      class="drawer-content"
      *ngIf="sidenav.opened"
      data-cy="mobile-menu-drawer-container"
    >
      <div class="user-section">
        <mat-expansion-panel
          [expanded]="true"
          class="mobile-user-expansion-panel"
        >
          <mat-expansion-panel-header>
            <ng-container *ngIf="currentUser$ | async as currentUser">
              <div class="user-expansion-panel-header">
                <common-mojo-avatar
                  [id]="currentUser?.photoId"
                  [selectedPhotoShape]="avatarPhotoShape"
                  [initials]="initials$ | async"
                  [backgroundSize]="avatarBackground"
                ></common-mojo-avatar>
                <span class="user-name">{{currentUser.firstName}}
                  {{currentUser.lastName}}</span>
              </div>
            </ng-container>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="user-menu-content">
              <a
                class="user-menu-item"
                data-cy="mobile-menu-account-settings-button"
                [routerLink]="['/account/profile']"
                (click)="sideNav.close()"
                *mojoHasPrivilege="privileges.settings.profile"
              >
                Account Settings</a>
              <a
                class="user-menu-item"
                data-cy="mobile-menu-users-link"
                [routerLink]="['/users']"
                (click)="sideNav.close()"
                *mojoHasPrivilege="privileges.settings.user"
              >
                User management
              </a>
              <a
                class="user-menu-item"
                [routerLink]="['/api-keys']"
                (click)="sideNav.close()"
                *mojoHasFeatureExtension="apiKeyFE"
              >
                API management
              </a>
              <a
                class="user-menu-item"
                [routerLink]="['/job-boards']"
                (click)="sideNav.close()"
                *mojoHasPrivilege="privileges.jobBoards.viewPage"
              >
                Job boards
              </a>
            </div>
          </ng-template>
        </mat-expansion-panel>
      </div>
      <mat-divider></mat-divider>
      <div class="nav-section">
        <a
          *mojoHasPrivilege="privileges.job.view"
          routerLink="/jobs"
          routerLinkActive="active"
          (click)="sideNav.close()"
          class="nav-link"
          data-cy="header-navigate-to-jobs"
        >Jobs</a>
        <ng-container>
          <a
            *mojoHasPrivilege="privileges.candidates.view"
            routerLink="/candidates"
            routerLinkActive="active"
            (click)="sideNav.close()"
            class="nav-link"
            data-cy="header-navigate-to-candidates"
          >Candidates</a>
        </ng-container>
        <ng-container *mojoHasFeatureExtension="talentPoolsFe">
          <ng-container *mojoHasPrivilege="talentPoolsPrivilege">
            <a
              routerLink="/talent-pools"
              routerLinkActive="active"
              *mojoHasPrivilege="privileges.reports.view"
              (click)="sideNav.close()"
              class="nav-link"
            >Talent pools</a>
          </ng-container>
        </ng-container>
        <ng-container>
          <a
            *mojoHasPrivilege="privileges.companies.view"
            routerLink="/companies"
            routerLinkActive="active"
            (click)="sideNav.close()"
            class="nav-link"
            data-cy="header-navigate-to-companies"
          >Companies</a>
        </ng-container>
        <ng-container *mojoHasFeatureExtension="referralReport">
          <a
            routerLink="/reports"
            routerLinkActive="active"
            *mojoHasPrivilege="privileges.reports.view"
            (click)="sideNav.close()"
            class="nav-link"
          >Reports</a>
        </ng-container>
        <ng-container *commonMojoHasFeatureAccess="conversionAndRoiReport">
          <a
            routerLink="/new-reports/conversion-and-roi"
            routerLinkActive="active"
            (click)="sideNav.close()"
            class="nav-link"
          >Conversion & ROI</a>
        </ng-container>
        <ng-container *commonMojoHasFeatureAccess="usageReport">
          <a
            routerLink="/new-reports/usage-report"
            routerLinkActive="active"
            (click)="sideNav.close()"
            class="nav-link"
          >Usage Report</a>
        </ng-container>
        <ng-container *commonMojoHasFeatureAccess="projectsReport">
          <a
            routerLink="/new-reports/projects-report"
            routerLinkActive="active"
            (click)="sideNav.close()"
            class="nav-link"
          >Projects Report</a>
        </ng-container>
        <ng-container *mojoHasFeatureExtension="pbiReportFe">
          <a
            routerLink="/pbi-report"
            routerLinkActive="active"
            (click)="sideNav.close()"
            class="nav-link"
          >Report
            MOBB</a>
        </ng-container>
      </div>
      <mat-divider></mat-divider>
      <div class="logout-section">
        <a
          class="nav-link"
          (click)="logout($event)"
          data-cy="mobile-menu-logout-button"
        >
          Log out</a>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content></mat-sidenav-content>
</mat-sidenav-container>
